
<template>
    <section
        :class="{
            'section': true,
            'section--last': isLastVisibleSection,
        }"
        v-if="!isHidden">
        <slot />
        <section-end-button
            v-if="sectionEndButtonInDom"
            :label="sectionEndButtonLabel"
            :is-disabled="sectionEndButtonIsDisabled"
            :next-section="nextSection"
            :is-shown="sectionEndButtonIsShown"
            @click="onSectionEndButtonClick" />
    </section>
</template>

<script>
import { mapState } from 'vuex';
import { Section } from '@/enums';
import SectionEndButton from '@/components/common/SectionEndButton';

export default {
    name: 'SectionWrapper',
    data () {
        return {
            Section,
        };
    },
    components: {
        SectionEndButton,
    },
    computed: {
        ...mapState(['openSections']),
        isHidden () {
            return !this.openSections.includes(this.thisSection);
        },
        sectionEndButtonIsShown () {
            return this.isLastVisibleSection;
        },
        isLastVisibleSection () {
            return this.openSections[this.openSections.length - 1].name === this.thisSection.name;
        },
    },
    props: {
        sectionEndButtonInDom: {
            type: Boolean,
            required: false,
            default: true,
        },
        thisSection: {
            type: Object,
            required: true,
        },
        nextSection: {
            type: Object,
            required: false,
            default: null,
        },
        sectionEndButtonIsDisabled: {
            type: Boolean,
            required: false,
            default: false,
        },
        sectionEndButtonLabel: {
            type: String,
            required: false,
            default: '',
        },
    },
    methods: {
        onSectionEndButtonClick () {
            this.$emit('sectionEndButtonClick');
        },
    },
};
</script>

<style scoped lang="scss">
.section {
  position: relative;
  background: $white;
  padding: 20px 15px 15px 15px;
  max-width: 100%;

  @include media-breakpoint-down(xs) {
    padding: 15px 10px 10px 10px;
  }

  & ~ .section {
    margin-top: 10px;
  }
}

.section--last {
  padding-bottom: 40px;
  margin-bottom: 20px;

  @include media-breakpoint-down(xs) {
    padding-bottom: 30px;
    margin-bottom: 0;
  }

  &::after {
    display: none;
  }
}
</style>
